import React, { useState, useCallback, useEffect } from "react";
import { ControlLabel, FormControl } from "react-bootstrap";
import { konturFocusGet } from "../../../api/player";
import { debounce } from "throttle-debounce";

export default ({ eventKey, name, label, required, value, onChange = () => { }, disabled }) => {

    const [search, setSearch] = useState(value || '');
    const [organizationsList, setOrganizationsList] = useState([]);

    const handleSearchOrganization = (search) => {
        konturFocusGet(eventKey, { search })
            .then((response) => {
                setOrganizationsList(response?.items || []);
            })
            .catch((error) => {
                console.error(error);
                setOrganizationsList([]);
            });
    };

    const handleSearch = useCallback(
        debounce(700, handleSearchOrganization)
        , []);

    const handleChange = (value) => {
        if (!value) {
            onChange({ organizationName: '', organizationInn: '', organizationKpp: '' });
            setOrganizationsList([]);
        }
        setSearch(value);
        handleSearch(value)
    }

    const handleUpdate = (organization) => {
        const { shortName, inn, kpp } = organization;
        setSearch(shortName);
        onChange({ organizationName: shortName, organizationInn: inn, organizationKpp: kpp });
        setOrganizationsList([]);
    }

    useEffect(() => {
        setSearch(value || '');
    }, [value])

    return <div style={{ position: 'relative' }}>
        <ControlLabel htmlFor={name}>{label}</ControlLabel>
        <FormControl
            type="text"
            name={name}
            required={required}
            value={search}
            onChange={(e) => handleChange(e.target.value)}
            disabled={disabled}
        />
        {!!organizationsList.length && <div style={{ position: 'absolute', border: '1px solid grey', background: 'white', padding: '0.5rem 1rem', maxHeight: '40rem', overflow: 'auto', width: '100%', zIndex: 100 }}>
            {organizationsList.map(organization =>
                <div key={organization.inn} style={{ borderBottom: '1px solid grey', padding: '0.5rem 0', cursor: 'pointer' }} onClick={() => handleUpdate(organization)}>
                    <div><strong>{organization.shortName}</strong></div>
                    <div style={{ width: '100%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{organization.address}</div>
                </div>
            )}
        </div>}
    </div>
}